import { I18n } from '@app/i18n/strings-keys';

export enum REPLENISH_APPLY_ITEMS_SCOPE {
  CHARGEABLE_ONLY = 'chargeable_only',
  NON_CHARGEABLE_ONLY = 'non_chargeable_only',
  ALL_ITEMS = 'all_items',
}

export enum REPLENISH_SCOPE_OPTIONS_VALUES {
  FILTERED_LIST = 'filtered_list',
  ALL_ITEMS = 'all_items',
}

export const REPLENISH_SCOPE_OPTIONS = [
  {
    text: I18n.Forms.GridForm.FilteredList,
    value: REPLENISH_SCOPE_OPTIONS_VALUES.FILTERED_LIST,
  },
  {
    text: I18n.Forms.GridForm.AllItems,
    value: REPLENISH_SCOPE_OPTIONS_VALUES.ALL_ITEMS,
  },
];

export enum ReplenishItemSiteType {
  // consider to change to From / To
  From = 'form',
  To = 'to',
}
